import { h } from 'preact';
import PureComponent from './PureComponent';
import getJSON from '../utils/get-json';
import { select } from "d3";
import { point, distance } from '@turf/turf';
import { geoScaleBar, geoScaleMiles, geoScaleTop } from 'd3-geo-scale-bar';

class DistrictMapMini extends PureComponent {
  constructor() {
    super();

    this.state = {};
  }

  drawScaleBar() {
    const { geometry, projection, width } = this.props;
    const office = geometry.properties.stats.office;
    const district = geometry.properties.district;
    const id = `district-map__scale-bar__${office}__${district}`

    const scaleBarSvg = select(`#${id}`).select('svg');
    scaleBarSvg.attr('width', width).attr('height', 20);

    const from = point([
      geometry.properties.meta.squared.bbox[0],
      geometry.properties.meta.squared.bbox[1],
    ])
    const to = point([
      geometry.properties.meta.squared.bbox[2],
      geometry.properties.meta.squared.bbox[1],
    ])
    const dist = distance(from, to, {
      units: 'miles'
    });
    const d = dist / 3.5 > 200
      ? Math.round(dist / 3.5 / 50) * 50
      : dist / 3.5 > 10
      ? Math.round(dist / 3.5 / 10) * 10
      : Math.round(dist / 3.5 / 5) * 5;

    const scaleBar = geoScaleBar()
      .projection(projection)
      .size([width, width])
      .left(1)
      .units(geoScaleMiles)
      .distance(d)
      .label(null)
      .orient(geoScaleTop)
      .tickPadding(5)
      .tickSize(0)
      .tickFormat((d, i, e) => i === e.length - 1 ? `${d} miles` : "")

    const scaleBarG = scaleBarSvg.select("g")
      .attr("class", 'scale-bar-g')
      .call(scaleBar)
      .attr('transform', `translate(0, 15)`)
    
    const scaleBarLength = scaleBarG.select('.domain').node().getTotalLength()

    scaleBarG.selectAll('text')
      .attr('transform', `translate(${-scaleBarLength / 2}, 0)`)
    scaleBarSvg.attr('width', scaleBarLength);
  }

  componentDidMount() {
    this.drawScaleBar();
  }

  componentDidUpdate(prevProps) {
    if (this.props !== prevProps) {
      this.drawScaleBar();
    }
  }

  render() {
    const { geometry } = this.props;
    const office = geometry.properties.stats.office;
    const district = geometry.properties.district;
    const id = `district-map__scale-bar__${office}__${district}`

    return (
      <div id={id} class="district-map__scale-bar">
        <svg>
          <g></g>
        </svg>
      </div>
    );
  }
}

export default DistrictMapMini;